/* ==========================================================================
   AMANSA — product-bundle.js
   Controla el bloque "Kit de tranquilidad" bajo el botón de compra en la
   PDP (Paso 3): el producto principal viene fijo, y el polvo cicatrizante
   / accesorios se añaden con una casilla. Es el cross-sell más importante
   de toda la tienda porque ataca directamente el miedo a hacer sangrar al
   animal en el propio momento de decisión de compra.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  const bundleWrap = document.querySelector('[data-pdp-bundle]');
  if (!bundleWrap) return;

  const mainVariantSelect = document.querySelector('[data-main-variant-id]');
  const totalEl = bundleWrap.querySelector('[data-bundle-total]');
  const addBtn = bundleWrap.querySelector('[data-bundle-add]');
  const checkboxes = bundleWrap.querySelectorAll('[data-bundle-item]');

  function currentMainVariantId() {
    return mainVariantSelect?.value || mainVariantSelect?.dataset.variantId;
  }

  function recalcTotal() {
    let total = parseInt(bundleWrap.dataset.mainPrice || '0', 10);
    checkboxes.forEach((cb) => {
      if (cb.checked) total += parseInt(cb.dataset.price || '0', 10);
    });
    if (totalEl) totalEl.textContent = window.AmansaFormatMoney(total);
  }

  checkboxes.forEach((cb) => cb.addEventListener('change', recalcTotal));
  recalcTotal();

  addBtn?.addEventListener('click', () => {
    const items = [{ id: currentMainVariantId(), quantity: 1 }];
    checkboxes.forEach((cb) => {
      if (cb.checked) items.push({ id: cb.dataset.variantId, quantity: 1 });
    });

    // El cart-drawer.js escucha este evento y hace la llamada a
    // cart/add.js con todas las líneas a la vez.
    document.body.dispatchEvent(new CustomEvent('amansa:add-bundle', { detail: { items } }));
  });
});

/* --- Comprar ahora ---
   Botón propio (no el widget nativo de Shopify) para que el estilo encaje
   con la marca: añade la variante actual por fetch y salta directo a
   checkout, sin pasar por el cajón del carrito. */
document.addEventListener('DOMContentLoaded', () => {
  const buyNowBtn = document.querySelector('[data-buy-now]');
  if (!buyNowBtn) return;

  buyNowBtn.addEventListener('click', () => {
    const variantInput = buyNowBtn.closest('form')?.querySelector('[data-main-variant-id]');
    const variantId = variantInput?.value;
    if (!variantId) return;

    const originalLabel = buyNowBtn.textContent;
    buyNowBtn.disabled = true;
    buyNowBtn.textContent = 'Redirigiendo…';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) => {
        if (!res.ok) throw new Error('No se pudo añadir al carrito');
        window.location.href = window.Shopify.routes.root + 'checkout';
      })
      .catch(() => {
        buyNowBtn.disabled = false;
        buyNowBtn.textContent = originalLabel;
      });
  });
});

/* --- Packs por niveles ---
   Cada nivel es un radio con la lista de variant IDs que incluye (siempre
   el producto principal + los complementos configurados en ese bloque).
   Reutiliza el mismo evento amansa:add-bundle que ya escucha cart-drawer.js. */
document.addEventListener('DOMContentLoaded', () => {
  const packWrap = document.querySelector('[data-pack-tiers]');
  if (!packWrap) return;

  const addBtn = document.querySelector('[data-pack-tier-add]');
  addBtn?.addEventListener('click', () => {
    const checked = packWrap.querySelector('[data-pack-tier-input]:checked');
    if (!checked) return;
    const ids = (checked.dataset.variantIds || '').split(',').filter(Boolean);
    const items = ids.map((id) => ({ id, quantity: 1 }));
    if (items.length) {
      document.body.dispatchEvent(new CustomEvent('amansa:add-bundle', { detail: { items } }));
    }
  });
});
